import { render, staticRenderFns } from "./BillingMethods.vue?vue&type=template&id=94ee2ad8"
import script from "./BillingMethods.vue?vue&type=script&lang=js"
export * from "./BillingMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports